import {objectById} from 'mc/lib/utils';
import React from 'react';
import {connect} from 'react-redux';
import {CurrentZadostActions} from '../../actions';
import {Api} from '../../api';
import {Subjekt} from '../subjekt';

const mapStateToProps = (state, {idRoleSubjekt}) => {
    const roleSubjekt = objectById(state.app.currentZadost.data.subjektList, idRoleSubjekt, 'idRoleSubjekt');
    return {
        subjekt: roleSubjekt ? roleSubjekt.subjekt : null,
    }
};

const mapDispatchToProps = (dispatch, {idZadost, idRoleSubjekt}) => ({
    onChange: newSubjekt => {
        return Api.setSubjekt(idZadost, idRoleSubjekt, newSubjekt).then(savedSubjekt => {
            dispatch(CurrentZadostActions.setSubjekt(idZadost, idRoleSubjekt, savedSubjekt));
        });
    },
    onDelete: () => {
        return Api.deleteSubjekt(idZadost, idRoleSubjekt).then(() => {
            dispatch(CurrentZadostActions.deleteSubjekt(idZadost, idRoleSubjekt));
        });
    },
    dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(Subjekt);
